module.exports = __webpack_public_path__ + "img/荆芥.a8f05847.jpg";